/**
 * Clue Column Drag Management
 *
 * Handles rendering and drag-and-drop of clue columns (oszlop divs)
 * in builder mode.
 */

import { appState } from '../state/AppState';
import { session } from './puzzleSession';

/**
 * Update the clue columns (oszlop divs) in builder mode.
 * This is the equivalent of the legacy updateMeghatarozasok() function.
 */
export function updateClueColumns(): void {
    if (!appState.isBuilderMode || !session.currentPuzzle) return;

    const clues = session.currentPuzzle.getClues();
    const columns = [
        clues.horizontal,
        clues.vertical,
        clues.horizontalBridge,
        clues.verticalBridge,
    ];

    for (let i = 0; i < columns.length; i++) {
        const colEl = document.getElementById(`oszlop-${i}`);
        if (colEl) {
            colEl.innerHTML = columns[i];
            attachColumnDragHandlers(colEl);
        }
    }
}

/**
 * Attach drag event handlers to a clue column element.
 */
function attachColumnDragHandlers(element: HTMLElement): void {
    element.onmousedown = onColumnMouseDown;
    element.onmouseup = onColumnMouseUp;
    element.ondblclick = onColumnDblClick;
}

/**
 * Handle mouse down on clue column for dragging.
 */
function onColumnMouseDown(e: MouseEvent): boolean | void {
    const target = e.target as HTMLElement;

    // Only drag if clicking on the column itself (with oszlop2 class)
    if (target.classList.contains('oszlop2') || target.closest('.oszlop2')) {
        const colEl = target.classList.contains('oszlop2')
            ? target
            : (target.closest('.oszlop2') as HTMLElement);

        session.dragState.dragElement = colEl;
        session.dragState.isDragging = true;

        colEl.style.position = 'relative';
        colEl.style.boxShadow = '0px 0px 3px 0px rgb(0, 0, 0)';

        session.dragState.offsetX = parseInt(colEl.style.left || '0', 10);
        session.dragState.offsetY = parseInt(colEl.style.top || '0', 10);
        session.dragState.startX = e.pageX;
        session.dragState.startY = e.pageY;

        document.onmousemove = onColumnMouseMove;
        return false;
    }
}

/**
 * Handle mouse up to stop dragging.
 */
function onColumnMouseUp(): void {
    session.dragState.isDragging = false;
    document.onmousemove = null;
}

/**
 * Handle double click to reset column position.
 */
function onColumnDblClick(e: MouseEvent): void {
    const target = e.target as HTMLElement;
    const colEl = target.classList.contains('oszlop2')
        ? target
        : (target.closest('.oszlop2') as HTMLElement);

    if (colEl) {
        colEl.style.position = 'static';
        colEl.style.left = '0px';
        colEl.style.top = '0px';
        colEl.style.boxShadow = '';
    }
}

/**
 * Handle mouse move while dragging a column.
 */
function onColumnMouseMove(e: MouseEvent): boolean | void {
    if (session.dragState.isDragging && session.dragState.dragElement) {
        session.dragState.dragElement.style.left =
            session.dragState.offsetX +
            e.pageX -
            session.dragState.startX +
            'px';
        session.dragState.dragElement.style.top =
            session.dragState.offsetY +
            e.pageY -
            session.dragState.startY +
            'px';
        return false;
    }
}
